/* Navigate to a verified internal URL, never blindly to browser history. */
(() => {
  const returnKey = 'chelin-back-destination';
  let arrivedViaBack = false;
  try {
    const pending = JSON.parse(sessionStorage.getItem(returnKey));
    sessionStorage.removeItem(returnKey);
    arrivedViaBack = pending?.path === window.location.pathname && Date.now() - pending.at < 15000;
  } catch {
    // Storage is optional; the internal Liquid fallback always remains available.
  }

  const updateBackLinks = () => {
    document.querySelectorAll('[data-chelin-back]').forEach((link) => {
      link.href = link.dataset.fallback;
      if (arrivedViaBack || !document.referrer) return;

      try {
        const previous = new URL(document.referrer);
        const current = new URL(window.location.href);
        if (previous.origin !== current.origin || previous.pathname === current.pathname) return;

        const root = new URL(link.dataset.root, current.origin).pathname.replace(/\/$/, '');
        const path = previous.pathname;
        if (root && path !== root && !path.startsWith(`${root}/`)) return;
        const storefrontPath = path.slice(root.length);
        const useful = storefrontPath === '' || storefrontPath === '/' ||
          /^\/(collections|products|pages|blogs)(\/|$)/.test(storefrontPath) ||
          /^\/search\/?$/.test(storefrontPath);
        if (useful) link.href = previous.href;
      } catch {
        // Missing, invalid or privacy-restricted referrers keep the Liquid fallback.
      }
    });
  };

  updateBackLinks();
  window.addEventListener('pageshow', updateBackLinks);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-chelin-back]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      // Avoid a product/collection loop: the destination uses its parent fallback.
      sessionStorage.setItem(returnKey, JSON.stringify({ path: new URL(link.href).pathname, at: Date.now() }));
    } catch {
      // Navigation itself does not depend on storage being allowed.
    }
  });
})();
